import { ClockPickerView } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useCallback, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { FormDateTimePicker } from "../../../../../../components/fields";
import useDebounceCallback from "../../../../../../hooks/useDebouncedCallback";
import { RentalLocationType } from "../../../../../../types";
import { shouldDisableRentalDate, shouldDisableRentalTime } from "../../../../../../utils";

import { IFormValues } from "../../../../types";
import {editTotalRentalDaysState, editPendingBookingRce} from "../../../../recoil";

const DropoffDate = () => {

    const { t } = useTranslation('booking');

    const totalRentalDays = useRecoilValue(editTotalRentalDaysState);

    const isPendingBookingRce = useRecoilValue<boolean | undefined>(editPendingBookingRce);

    const { getValues, trigger } = useFormContext<IFormValues>();

    const pickupDate = useWatch<IFormValues, "basicDetails.pickupDate">({
        name: 'basicDetails.pickupDate'
    });

    const currentDate = useMemo(() => dayjs(), []);

    const shouldDisableDate = useCallback((date: dayjs.Dayjs) => {
        return shouldDisableRentalDate(date, getValues('basicDetails.dropoffLocation'), RentalLocationType.Dropoff);
    }, []);
    const shouldDisableTime = useCallback((time: number, clockTime: ClockPickerView) => {
        return shouldDisableRentalTime(time, clockTime, RentalLocationType.Dropoff, getValues('basicDetails.dropoffLocation'), getValues('basicDetails.dropoffDate'));
    }, []);
    const handleChange = useDebounceCallback(() => {
        trigger('basicDetails.dropoffDate');
    }, 300, []);

    return (
        <FormDateTimePicker<IFormValues>
            name="basicDetails.dropoffDate"
            label={t('label.dropoffDate')}
            onChange={handleChange}
            disabled={isPendingBookingRce}
            minDateTime={pickupDate || currentDate || undefined}
            maxDateTime={pickupDate?.add(30, 'day') || currentDate.add(30, 'day')}
            shouldDisableDate={shouldDisableDate}
            shouldDisableTime={shouldDisableTime}
            textFieldProps={{
                helperText: `Total Rental Days: ${totalRentalDays}`,
            }}
        />
    );
};

export default DropoffDate;
